export const AUTH_LOGOUT = 'auth:logout'
export const PAGE_LOADING_START = 'page:loading:start'
export const PAGE_LOADING_END = 'page:loading:end'
export const NAV_LOADING_START = 'nav:loading:start'
export const NAV_LOADING_END = 'nav:loading:end'
export const PAGE_LEND_RESET = 'page:lend:reset'
export const PAGE_LEND_STORE_RESET = 'page:lend:store:reset'
export const PAGE_BIBLIOGRAPHIES_RESET = 'page:bibliographies:reset'
export const PAGE_USER_RESET = 'page:user:reset'
export const PAGE_REFERENCE_RESET = 'page:reference:reset'
export const LEND_USER_INFO_BASIC_INPUT_FIELD_FOCUS =
  'lend:user:info:basic:input:field:focus'
export const LEND_LIST_INPUT_COLLECTION_NO_FOCUS =
  'lend:list:input:collection:no:focus'
export const LEND_OUT_LIST_INPUT_COLLECTION_NO_FOCUS =
  'lend:out:list:input:collection:no:focus'
export const LEND_LIST_TAB_RESET = 'lend:list:tab:reset'
export const PAGE_RETURN_INPUT_COLLECTION_ID_FOCUS =
  'page:return:input:collection:id:focus'
export const PAGE_RETURN_COLLECTION_RESET = 'page:return:collection:reset'
export const PAGE_RETURN_BORROW_COLLECTION_RESET =
  'page:return:borrow:collection:reset'
export const BIBLIOGRAPHY_CLOSED = 'bibliography:closed'
export const CHANGED_PROCESS_PLACE = 'changed:process:place'
export const DATA_STORE_FETCHED = 'data:store:fetched'
export const RECEIVED_CONNECT_PARAMETER = 'received:connect:parameter'
export const APP_KEYDOWN = 'app:keydown'
export const APP_KEYUP = 'app:up'
